
export const fetchToken = () => {
    let userToken= null;
    userToken = localStorage.getItem('token') ? `Bearer ${JSON.parse(localStorage.getItem('token'))}` : localStorage.clear() ;
    return userToken;
}

 